module.exports = __webpack_public_path__ + "eb2243d17a22676a6f41839f4d7b5a68.svg";